// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.quill-wrapper {
  display: flex;
  flex-direction: column;
  overflow: hidden;
  border: 1px solid #dadfe2;
  border-radius: 6px;
}
.quill-wrapper:focus-within {
  outline: 2px solid #cbf0fd;
  border-color: #54d2ff;
  caret-color: #13b9ff;
}
.quill-wrapper:focus-within .ql-toolbar {
  border-color: #54d2ff !important;
}
.quill-wrapper.is-error:focus-within {
  border-color: #fca5a5;
  outline: 2px solid #fee2e2;
}
.quill-wrapper.is-error:focus-within .ql-toolbar,
.quill-wrapper.is-error:focus-within .ql-container {
  border-color: #fca5a5 !important;
  caret-color: #ef4444;
}

.quill {
  display: flex;
  flex-direction: column;
}
.quill.is-resizeX .ql-editor {
  resize: horizontal;
}
.quill.is-resizeY .ql-editor {
  resize: vertical;
}
.quill .ql-container {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  overflow-y: auto;
}
.quill .ql-container.ql-snow {
  border: none;
  border-bottom-right-radius: 6px;
  border-bottom-left-radius: 6px;
}
.quill .ql-toolbar.ql-snow {
  border: none;
  border-bottom: 1px solid #dadfe2;
  border-top-right-radius: 6px;
  border-top-left-radius: 6px;
}
.quill .ql-toolbar .ql-header {
  display: flex;
  align-items: center;
}
.quill .ql-toolbar .ql-header svg {
  opacity: 0;
}
.quill .ql-toolbar .ql-header.ql-header[value="1"]::before {
  content: "H1";
  font-weight: 500;
}
.quill .ql-toolbar .ql-header.ql-header[value="2"]::before {
  content: "H2";
  font-weight: 500;
}
.quill .ql-toolbar .ql-header.ql-header[value="3"]::before {
  content: "H3";
  font-weight: 500;
}
.quill .ql-editor {
  flex-grow: 1;
}
.quill .ql-editor > * {
  color: #1b2123 !important;
  font-size: 14px;
}
.quill .ql-editor li {
  list-style-position: inside !important;
}
.quill .ql-editor.ql-blank:before {
  font-style: normal;
  font-size: 14px;
  font-weight: 400;
  --tw-text-opacity: 1;
  color: rgb(113 118 128 / var(--tw-text-opacity, 1));
}
.quill .ql-editor[contenteditable=false] p {
  cursor: not-allowed;
}
.quill .ql-editor[contenteditable=false]:before {
  --tw-text-opacity: 1;
  color: rgb(213 215 218 / var(--tw-text-opacity, 1));
}

.ql-editor {
  word-break: break-word;
}`, "",{"version":3,"sources":["webpack://./src/components/shared/TextEditor/lib/TextEditor.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,yBAAA;EACA,kBAAA;AACF;AACE;EACE,0BAAA;EACA,qBAAA;EACA,oBAAA;AACJ;AAAI;EACE,gCAAA;AAEN;AAGI;EACE,qBAAA;EACA,0BAAA;AADN;AAEM;;EAEE,gCAAA;EACA,oBAAA;AAAR;;AAMA;EACE,aAAA;EACA,sBAAA;AAHF;AAMI;EACE,kBAAA;AAJN;AAQI;EACE,gBAAA;AANN;AAUE;EACE,aAAA;EACA,sBAAA;EACA,YAAA;EACA,gBAAA;AARJ;AAUI;EACE,YAAA;EACA,+BAAA;EACA,8BAAA;AARN;AAaI;EACE,YAAA;EACA,gCAAA;EACA,4BAAA;EACA,2BAAA;AAXN;AAcI;EACE,aAAA;EACA,mBAAA;AAZN;AAaM;EACE,UAAA;AAXR;AAaM;EACE,aAAA;EACA,gBAAA;AAXR;AAcM;EACE,aAAA;EACA,gBAAA;AAZR;AAeM;EACE,aAAA;EACA,gBAAA;AAbR;AAkBE;EACE,YAAA;AAhBJ;AAiBI;EACE,yBAAA;EACA,eAAA;AAfN;AAiBI;EACE,sCAAA;AAfN;AAkBM;EACE,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,oBAAA;EAAA,mDAAA;AAhBR;AAoBM;EACE,mBAAA;AAlBR;AAqBQ;EAAA,oBAAA;EAAA;AAAA;;AAMR;EACE,sBAAA;AArBF","sourcesContent":[".quill-wrapper {\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  border: 1px solid #dadfe2;\n  border-radius: 6px;\n\n  &:focus-within {\n    outline: 2px solid #cbf0fd;\n    border-color: #54d2ff;\n    caret-color: #13b9ff;\n    .ql-toolbar {\n      border-color: #54d2ff !important;\n    }\n  }\n\n  &.is-error {\n    &:focus-within {\n      border-color: #fca5a5;\n      outline: 2px solid #fee2e2;\n      .ql-toolbar,\n      .ql-container {\n        border-color: #fca5a5 !important;\n        caret-color: #ef4444;\n      }\n    }\n  }\n}\n\n.quill {\n  display: flex;\n  flex-direction: column;\n\n  &.is-resizeX {\n    .ql-editor {\n      resize: horizontal;\n    }\n  }\n  &.is-resizeY {\n    .ql-editor {\n      resize: vertical;\n    }\n  }\n\n  .ql-container {\n    display: flex;\n    flex-direction: column;\n    flex-grow: 1;\n    overflow-y: auto;\n\n    &.ql-snow {\n      border: none;\n      border-bottom-right-radius: 6px;\n      border-bottom-left-radius: 6px;\n    }\n  }\n\n  .ql-toolbar {\n    &.ql-snow {\n      border: none;\n      border-bottom: 1px solid #dadfe2;\n      border-top-right-radius: 6px;\n      border-top-left-radius: 6px;\n    }\n\n    & .ql-header {\n      display: flex;\n      align-items: center;\n      svg {\n        opacity: 0;\n      }\n      &.ql-header[value='1']::before {\n        content: 'H1';\n        font-weight: 500;\n      }\n\n      &.ql-header[value='2']::before {\n        content: 'H2';\n        font-weight: 500;\n      }\n\n      &.ql-header[value='3']::before {\n        content: 'H3';\n        font-weight: 500;\n      }\n    }\n  }\n\n  .ql-editor {\n    flex-grow: 1;\n    & > * {\n      color: #1b2123 !important;\n      font-size: 14px;\n    }\n    li {\n      list-style-position: inside !important;\n    }\n    &.ql-blank {\n      &:before {\n        font-style: normal;\n        font-size: 14px;\n        font-weight: 400;\n        @apply text-neutral-500;\n      }\n    }\n    &[contenteditable='false'] {\n      p {\n        cursor: not-allowed;\n      }\n      &:before {\n        @apply text-neutral-300;\n      }\n    }\n  }\n}\n\n.ql-editor {\n  word-break: break-word;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
